enum Platform {
  Android = 'android',
  Ios = 'ios',
  Web = 'web',
}

export default Platform;
